// src/utils/device.js
export function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}
export function isSebPlatform() {
    // Win/macOS/iOS – platformy docelowe dla SEB
    return /Windows|Macintosh|Mac OS X|iPhone|iPad|iPod/i.test(navigator.userAgent);
}
